import React, { useContext, useEffect, useState } from "react";
import Cardd from "../../ui/Card";
import axios from "axios";
import {
  updateImage,
  updateProfile,
  useFetchData,
} from "../../hooks/useFetchData";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import { textAlign } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useQueryClient } from '@tanstack/react-query'; // or '@tanstack/react-query' for v4+
import {
  Backdrop,
  Box,
  Button,
  Drawer,
  Fade,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { QueryClient, useMutation } from "@tanstack/react-query";
import { UserImageContext } from "../../context/usecontextImage";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Carddcar from "../../ui/Cardcar";
import { MdOutlineHomeWork } from "react-icons/md";
import { MdOutlineDirectionsCarFilled } from "react-icons/md";
import { TestLanguage } from "../../hooks/testLanguage";
import { toast, ToastContainer } from "react-toastify";
import Drawer2 from "../../component/Drawer2";
import Drawercar from "../Cars/Drawer2";
import { usecontextUser } from "../../context/usecontextUser";

function Profile() {
  const {user} =useContext(usecontextUser)
  const [value, setValue] = React.useState("1");
const closeModal = () => {
    setModalIsOpen(false);
  };
  const handleChange2 = (event, newValue) => {
    setValue(newValue);
  };
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(null);
    const [selectedPoint2, setSelectedPoint2] = useState(null);
  const { userImage, updateUserImage } = useContext(UserImageContext);
  const { t } = useTranslation();
  const [datacard, setDatacard] = useState(null);
  const [userid, setUserid] = useState(user.id);
  const [preview, setPreview] = useState(null);
  const [item, setItem] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [iddeleted, setIddeleted] = useState()
  const queryClient = useQueryClient();
  const handleOpen = (id) => {
    setIddeleted(id)
    console.log("ggg", id);

    setOpen(true)
  };
  const handleClose = () => setOpen(false);
      useEffect(()=>{
    setUserid(localStorage.getItem("userId"))
  },[])
const { data: datastatus } = useFetchData(
    `${process.env.REACT_APP_API_URL}getusersubscribe?user_id=${localStorage.getItem("userId")}`
  );
  console.log("datastatus",datastatus);
  
  const { data: data2 } = useFetchData(
    `${process.env.REACT_APP_API_URL}units?filter[post.user_id]=${userid}&sort=-created_at`
  );
  console.log("data2", data2);
  const { data: data3 } = useFetchData(
    `${process.env.REACT_APP_API_URL}cars?filter[post.user_id]=${userid}&sort=-created_at`
  );
  useEffect(() => {
    const storedImage = localStorage.getItem("user_image");
    if (storedImage) {
      setFormData((prev) => ({ ...prev, image: storedImage }));
    }
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "genders")
      .then((res) => {
        setItem(res.data.data); // adjust based on API structure
      })
      .catch((err) => {
        console.error("Error fetching items", err);
      });
  }, []);
  const url = `${process.env.REACT_APP_API_URL}checkSubs?user_id=${userid}`;
  const { data, isLoading, error } = useFetchData(url);
  console.log("data", data);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    gender_id: "",
    mobile: "",
    password_confirmation: "",
    birth_date: "",
    image: null,
    address: "",
    whatsapp: "",
    license_number: "",
  });
  const mutation = useMutation({
    mutationFn: updateImage,
    onSuccess: (data) => {
      console.log("Posted successfully", data);
      if (data?.user?.image) {
        setFormData((prev) => ({
          ...prev,
          image: data.user.image,
        }));
      }
    },
    onError: (error) => {
      console.error("Posting failed", error.message);
    },
  });
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL + "users?filter[id]=" + userid
      )
      .then((response) => {
        // بافتراض أن الـ API يرجع كائن بنفس بنية النموذج
        setFormData(response.data.data[0]);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("حدث خطأ أثناء تحميل البيانات:", error);
      });
  }, []);
  const handleSend = () => {

    async function deletePost() {
      try {
       const token = localStorage.getItem("token"); // get token

    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}units/${iddeleted}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    console.log(response);
    toast.success("Deleted successfully");
    setOpen(false);
    queryClient.invalidateQueries(['posts', userid]);
      } catch (error) {
        console.error(error);
      }

    }
    deletePost()
  };

   const handleSendcar = () => {
 const token = localStorage.getItem("token");
    async function deletePost() {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}cars/${iddeleted}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
        console.log(response);
        toast.success("deleted successfully")
        setOpen(false)
        queryClient.invalidateQueries(['posts', userid]);
      } catch (error) {
        console.error(error);
      }

    }
    deletePost()
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleClick = () => {
    document.getElementById("upload-image").click();
  };
   
  const handleSubmitImage = (e) => {
    const file = e.target.files[0];
    if (!userid) {
      console.error("User ID is missing");
      return;
    }
    if (!file) return;

    console.log(file, userid);

    const objectUrl = URL.createObjectURL(file);
    setPreview(file);

    const formData = new FormData();
    formData.append("user_image", file);
    formData.append("id", user.id);

    mutation.mutate(formData, {
      onSuccess: (response) => {
        const imageUrl = response?.data?.image; // adjust based on your backend
        if (imageUrl) {
          localStorage.setItem(
            "user_image",
            process.env.REACT_APP_IMAGE + imageUrl
          );
          updateUserImage(process.env.REACT_APP_IMAGE + imageUrl);
        }
      },
    });
  };
  const openModal = (data) => {
    console.log("data", data);

    setSelectedPoint(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
 const openModalcar = (data) => {
    console.log("data", data);

    setSelectedPoint2(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
  const updateMutation = useMutation({
    mutationFn: updateProfile,
    onSuccess: (data) => {
      console.log("Profile updated:", data);
    },
    onError: (error) => {
      console.error("Update failed:", error.message);
    },
  });
  const handleSubmit = () => {
    const form = new FormData();
    form.append("id", userid);
    form.append("name", formData.name || "");
    form.append("email", formData.email || "");
    form.append("mobile", formData.mobile || "");
    form.append("whatsapp", formData.whatsapp || "");
    form.append("gender_id", formData.gender_id || "");
    form.append("address", formData.address || "");
    form.append("birth_date", formData.birth_date || "");
    form.append("license_number", formData.license_number || "");

    updateMutation.mutate(form);
  };
  console.log("selectedPoint",selectedPoint);
  
   const DrawerComponent = selectedPoint?.type !== "project" ? Drawer2 : "";
   const DrawerComponent2 = selectedPoint2?.type !== "project" ?  Drawercar:"";
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
console.log('mdata',data3);

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            {" "}
            <div
              style={{
                textAlign: "center",
                borderRadius: "8px",
                padding: "16px",
                boxshadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                margin: "0 auto",
              }}
              className="row"
            >
              <ToastContainer />
              <div>
                <>
                  <input
                    type="file"
                    accept="image/*"
                    id="upload-image"
                    style={{ display: "none" }}
                    onChange={handleSubmitImage}
                  />

                  <Tooltip
                    placement="bottom-end"
                    arrow
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        fontSize: "1.2rem",
                      },
                    }}
                    title={t("SignUp.buttonsaveimage")}
                  >
                    <IconButton
                      onClick={handleClick}
                      sx={{
                        p: 0,
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                          boxShadow: 3,
                        },
                        "&:active": {
                          transform: "scale(0.95)",
                        },
                      }}
                    >
                      <Avatar
                        sx={{ width: 128, height: 128, margin: "0 auto" }}
                        alt="User Avatar"
                        src={userImage}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              </div>{" "}
              <div style={{ textAlign: "center" }}>
                <h2>{formData?.name}</h2>
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.fullname")}</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder={t("SignUp.fullname")}
                  autoComplete="off"
                  name="name"
                  id="name"
                  onChange={handleChange}
                  value={formData?.name || data?.name}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.mobile")}</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder={t("SignUp.mobile")}
                  autoComplete="off"
                  name="mobile"
                  id="mobile"
                  onChange={handleChange}
                  value={formData?.mobile}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.whatssapp")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("SignUp.whatssapp")}
                  autoComplete="off"
                  name="whatsapp"
                  id="whatsapp"
                  onChange={handleChange}
                  value={formData?.whatsapp}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.email")}</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={t("SignUp.email")}
                  autoComplete="off"
                  name="email"
                  id="email"
                  onChange={handleChange}
                  value={formData?.email}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.gender")}</label>

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t("SignUp.gender")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="gender"
                    id="gender"
                    value={formData?.gender_id}
                    label="Age"
                    onChange={handleChange}
                  >
                    {item?.map((i) => (
                      <MenuItem value={i.id}>
                        {localStorage.getItem("lang") === "ar"
                          ? i?.name
                          : i.name_en}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.address")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("SignUp.address")}
                  autoComplete="off"
                  name="address"
                  id="address"
                  onChange={handleChange}
                  value={formData?.address}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.birthdate")}</label>

                <input
                  type="date"
                  className="form-control"
                  placeholder={t("SignUp.birthdate")}
                  autoComplete="off"
                  name="birthdate"
                  id="birthdate"
                  onChange={handleChange}
                  value={formData?.birth_date}
                />
              </div>
              <div
                className="col-md-12 mt-4"
                style={{ textAlign: t("directions.align") }}
              >
                <label for="date">{t("SignUp.license")}</label>
              </div>
              <div className="col-md-12">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("SignUp.license")}
                  autoComplete="off"
                  name="license_number"
                  id="license_number"
                  onChange={handleChange}
                  value={formData?.license_number}
                />
              </div>
              <div className="col-md-12 my-4">
                <Button
                  onClick={handleSubmit}
                  sx={{
                    background: "#232324",
                    color: "#fff",
                    fontFamily: "Oswald, cairo",
                    fontSize: "16px",
                    fontWeight: 300,
                    marginRight: "10px",
                  }}
                >
                  {t("SignUp.buttonSave")}
                </Button>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <h2 style={{ textAlign: "center" }}>{t("SignUp.Myposts")}</h2>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                m: "50px 10px",
                p: "50px 10px",
                background: "#f5f5f5",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h4 style={{ textAlign: "center" }}>{t("SignUp.Adv1")}</h4>{" "}
                <h2>{data?.count_available_free_post}</h2>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {" "}
                <h4 style={{ textAlign: "center" }}>{t("SignUp.Adv2")}</h4>{" "}
                <h2>{data?.count_available_subscribtion_post}</h2>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h4 style={{ textAlign: "center" }}>{t("SignUp.Adv3")}</h4>{" "}
                <h2>{data?.count_available_post}</h2>
              </div>
            </Box>
            <div
              className="row"
              style={{
                textAlign: "center",
                borderRadius: "8px",
                padding: "16px",
                boxshadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                margin: "0 auto",
              }}
            >
           {datastatus?.status === true ?<h4>
                {t("drawerUnit.packedgename")}{TestLanguage(datastatus?.data?.package, "name")}  {t("drawerUnit.packedgedata")}{datastatus?.data?.end_date}
              </h4>
              :<h4>{t("drawerUnit.dontsubsecribe")}</h4>}
             
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleChange2}
                      aria-label="lab API tabs example"
                    >
                      <Tab sx={{ fontFamily: 'oswald,cairo', fontSize: '16px' }} icon={<MdOutlineHomeWork size={24} />} label={t("nav.realestate")} value="1" />
                      <Tab sx={{ fontFamily: 'oswald,cairo', fontSize: '16px' }} icon={<MdOutlineDirectionsCarFilled size={24} />} label={t("nav.cars")} value="2" />
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    {" "}
                    {(datacard?.data?.length > 0
                      ? datacard?.data
                      : data2?.data || []
                    ).map((i, index) => (
                      <div
                        style={{ textAlign: "center", margin: "30px 0px" }}
                        className="col-md-4 col-sm-12"
                        key={i.id || index}
                        size={6}
                       
                      >
                        <div>
                          
                          <div style={{
                            backgroundColor: i.post.status.id === 1 ? "#f5f5f5"
                              : i.post.status.id === 2 ? "#697565"
                                : i.post.status.id === 4 ? "#CAE8BD"
                                  : "#D2665A", borderRadius: "5px 5px 0 0 ", display: "flex", justifyContent: "space-between", paddingLeft: "8px", alignItems: "center", color: i.post.status.id === 5 ? "#f5f5f5" :
                                    i.post.status.id === 2 ? "#fff"
                                      : "#000"
                          }}>
                            <Tooltip
                              title={
                                <span style={{ fontSize: '15px', }}>
                                  {t("drawerUnit.delete")}
                                </span>
                              }
                            >

                              <a style={{ cursor: "pointer" }} onClick={() => handleOpen(i.id)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="#232324"
                                  class="bi bi-x-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                                </svg>
                              </a>

                            </Tooltip>

                            <h5 style={{ padding: "8px", margin: "0" }}>{TestLanguage(i.post.status, "name")}</h5>

                          </div>
                          <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            slots={{ backdrop: Backdrop }}
                            slotProps={{
                              backdrop: {
                                timeout: 500,
                              },
                            }}
                          >
                            <Fade in={open}>
                              <Box sx={style}>
                                <Typography id="transition-modal-title" variant="h4" component="h2">
                                  are you sure for delete this post???
                                </Typography>
                                <div style={{ marginTop: "50px", display: "flex", justifyContent: "end" }}>
                                  <Button variant="contained" color="success" sx={{ margin: "5px" }} onClick={handleSend}>ok</Button>
                                  <Button variant="outlined" color="error" sx={{ margin: "5px" }} onClick={handleClose}>no</Button>
                                </div>
                              </Box>
                            </Fade>
                          </Modal>
                        </div>
                     <span onClick={() => openModal(i)}> <Cardd data={i} /></span>  

                      </div>
                    ))}

                  </TabPanel>
                  <TabPanel value="2">
                      {" "}
                    {(datacard?.data?.length > 0
                      ? datacard?.data
                      : data3?.data || []
                    ).map((i, index) => (
                      <div
                        style={{ textAlign: "center", margin: "30px 0px" }}
                        className="col-md-4 col-sm-12"
                        key={i.id || index}
                        size={6}
                        
                      >
                        <div>
                          
                          <div style={{
                            backgroundColor: i.post.status.id === 1 ? "#f5f5f5"
                              : i.post.status.id === 2 ? "#697565"
                                : i.post.status.id === 4 ? "#CAE8BD"
                                  : "#D2665A", borderRadius: "5px 5px 0 0 ", display: "flex", justifyContent: "space-between", paddingLeft: "8px", alignItems: "center", color: i.post.status.id === 5 ? "#f5f5f5" :
                                    i.post.status.id === 2 ? "#fff"
                                      : "#000"
                          }}>
                            <Tooltip
                              title={
                                <span style={{ fontSize: '15px', }}>
                                  {t("drawerUnit.delete")}
                                </span>
                              }
                            >

                              <a style={{ cursor: "pointer" }} onClick={() => handleOpen(i.id)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="#232324"
                                  class="bi bi-x-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                                </svg>
                              </a>

                            </Tooltip>

                            <h5 style={{ padding: "8px", margin: "0" }}>{TestLanguage(i.post.status, "name")}</h5>

                          </div>
                          <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            slots={{ backdrop: Backdrop }}
                            slotProps={{
                              backdrop: {
                                timeout: 500,
                              },
                            }}
                          >
                            <Fade in={open}>
                              <Box sx={style}>
                                <Typography id="transition-modal-title" variant="h4" component="h2">
                                  are you sure for delete this post???
                                </Typography>
                                <div style={{ marginTop: "50px", display: "flex", justifyContent: "end" }}>
                                  <Button variant="contained" color="success" sx={{ margin: "5px" }} onClick={handleSendcar}>ok</Button>
                                  <Button variant="outlined" color="error" sx={{ margin: "5px" }} onClick={handleClose}>no</Button>
                                </div>
                              </Box>
                            </Fade>
                          </Modal>
                        </div>
                     <span onClick={() => openModalcar(i)}><Carddcar data={i} /></span>   
                      </div>
                    ))}
                  </TabPanel>
                </TabContext>
               
              </Box>
            </div>
          </div>
        </div>
          {selectedPoint && (
                        <DrawerComponent
                          point={selectedPoint?.id}
                          isOpen={modalIsOpen}
                          onClose={closeModal}
                        >
                          {/* <h2>{selectedPoint?.name}</h2>
                                   <p>{selectedPoint?.description}</p> */}
                          <h2>{TestLanguage(selectedPoint?.offertype, "name")}</h2>
                          <h2>{TestLanguage(selectedPoint, "name")}</h2>
                          <p>{TestLanguage(selectedPoint, "description")}</p>
                        </DrawerComponent>
                      )}
                       {selectedPoint2 && (
                        <DrawerComponent2
                          point={selectedPoint2?.id}
                          isOpen={modalIsOpen}
                          onClose={closeModal}
                        >
                          {/* <h2>{selectedPoint?.name}</h2>
                                   <p>{selectedPoint?.description}</p> */}
                          <h2>{TestLanguage(selectedPoint2?.offertype, "name")}</h2>
                          <h2>{TestLanguage(selectedPoint2, "name")}</h2>
                          <p>{TestLanguage(selectedPoint2, "description")}</p>
                        </DrawerComponent2>
                      )}
      </div>
    </div>
  );
}

export default Profile;
